import { render, staticRenderFns } from "./ServiceShortcuts.vue?vue&type=template&id=0fcf2318&scoped=true"
import script from "./ServiceShortcuts.vue?vue&type=script&lang=js"
export * from "./ServiceShortcuts.vue?vue&type=script&lang=js"
import style0 from "./ServiceShortcuts.vue?vue&type=style&index=0&id=0fcf2318&prod&lang=scss&scoped=true"
import style1 from "./ServiceShortcuts.vue?vue&type=style&index=1&id=0fcf2318&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf2318",
  null
  
)

export default component.exports